module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogTop":{"iconLabel":"Nevíte si rady?","hideContentLabel":"Skrýt popis","showContentLabel":"Číst více"}},"de":{"CatalogTop":{"iconLabel":"Sie wissen nicht, was Sie tun sollen?","hideContentLabel":"Beschreibung ausblenden","showContentLabel":"Mehr lesen"}},"sk":{"CatalogTop":{"iconLabel":"Neviete si rady?","hideContentLabel":"Skryť popis","showContentLabel":"Čítať viac"}}}')
  delete Component.options._Ctor
}
